<style lang="less">
@import "../../../../styles/public/public.less";
@import "../less/district_district.less";
// #district_state_echart {
//   height: 600px;
// }
</style>
<template>
  <div class="district_district">
    <div class="district_district1 display_column">
      <div class="district_district_top dispaly_flex00 media_w_w18 display_row_ac">
        <div class="district_district_top_1"></div>
        <span>科研状态</span>
      </div>
      <div class="district_district_bottom dispaly_flex11">
        <div :id="chartid" class="district_status_eacharts"></div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "../../../../app/event"
export default {
  components: {},
  props:{
    chartid:String,
  },
  data() {
    return {};
  },
  methods: {
    initEcharts(data) {
      let ydata=[];
      let xdata=[];
      data.map(item=>{
        xdata.push(item.NUM);
        ydata.push(item.STEPNAME)
      })
      xdata.reverse();
      ydata.reverse();
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          width: "90%",
          height: "95%",
          top: "4%",
          left: "1%",
          right: "4%",
          bottom: "10%",
          containLabel: true
        },

        calculable: true,
        yAxis: [
          {
            type: "category",
            data: ydata,
            axisTick: {
              show: false
              // alignWithLabel: true
            },
            axisLine: {
              lineStyle: {
                color: "#000000"
              }
            },
            axisLabel: {
              color: "#000000",
              // rotate: "20", //旋转角度
              fontSize: "15"
            }
          }
        ],
        xAxis: [
          {
            show: true, // 是否显示
            splitLine: {
              show: false, // 是否显示
              lineStyle: {
                color: "#295868"
                // width: 1,
                // type: 'solid'
              }
            },
            type: "value",
            min: 0,
            max:  function(value) {
                return value.max + 2;
            },
            minInterval: 1,
            axisLabel: {
              fontSize: "15",
              color: "#000000"
            },
            axisLine: {
              lineStyle: {
                color: "#295868"
              }
            }
          }
        ],
        series: [
          {
            itemStyle: {
              normal: {
                color: "#04D061",
                label: {
                  show: true,
                  position: "right",
                  textStyle: {
                    color: "black"
                  }
                },
                //柱形图圆角，初始化效果
                barBorderRadius: [0, 5, 5, 0],
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#b0e707"
                  },
                  {
                    offset: 1,
                    color: "#4fd804"
                  }
                ])
              }
            },

            type: "bar",
            barWidth: "20%",
            data: xdata
          }
        ]
      };

      let district_state_echart = document.getElementById(
        this.chartid
      );
      var mydistrict_state_echart = this.$echarts.init(district_state_echart);
      mydistrict_state_echart.setOption(option, true);
    }
  },
  mounted() {
    bus.$on('scistatue',this.initEcharts);
  },
  beforeDestroy(){
    bus.$off('scistatue');
  },
  directives: {}
};
</script>




// WEBPACK FOOTER //
// district_state.vue?30e24b54